import React from 'react';
import { Grid } from '@material-ui/core';
import {
  BackdropCircular,
  Breadcrumb
} from 'components';
import QuotePatient from './QuotePatient/QuotePatient';


const QuotingPage = () => {
  return (
    <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Create Quote' }
          ]}
        />
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <QuotePatient />
            </Grid>
          </Grid>
        </Grid>
        <BackdropCircular loading={false} />
      </Grid>
    </div>
  );
};

export default QuotingPage;
